exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-screen[data-v-125eea9c]{width:100vw;height:100vh;position:fixed;top:0;left:0;background-color:#fff;z-index:999;overflow:auto}", ""]);

// exports
